export interface Anime {
  id: string;
  title: string;
  cover: string;
  banner?: string;
  categories: string[];
  region: string;
  year: number;
  episodes: number;
  status: string;
  rating: number;
  director: string;
  views: number;
  description: string;
  latestEpisode: string;
  updatedAt: string;
}

export const animeCategories = [
  "热血",
  "恋爱",
  "奇幻",
  "科幻",
  "校园",
  "日常",
  "悬疑",
  "治愈",
  "冒险",
  "运动",
  "搞笑",
];

export const animeRegions = ["日本", "中国", "美国", "韩国"];

export const animeYears = [2025, 2024, 2023, 2022, 2021];

export const animeStatuses = ["连载中", "已完结"];

export const animeList: Anime[] = [
  {
    id: "star-voyage",
    title: "星海征途",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20space%20captain%20gazing%20at%20distant%20galaxies%2C%20soft%20sakura%20pink%20and%20sky%20blue%20color%20palette%2C%20clean%20minimal%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%20digital%20painting%2C%20vibrant%20youthful%20atmosphere%2C%20no%20text&width=400&height=560&seq=anime-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20landscape%20of%20a%20starship%20sailing%20through%20a%20nebula%20of%20soft%20pink%20and%20blue%20stars%2C%20dramatic%20glowing%20sky%2C%20atmospheric%20lighting%2C%20detailed%20digital%20painting%2C%20epic%20composition%2C%20no%20text&width=1600&height=700&seq=anime-banner-01&orientation=landscape",
    categories: ["热血", "科幻", "冒险"],
    region: "日本",
    year: 2024,
    episodes: 24,
    status: "连载中",
    rating: 9.2,
    director: "新海圭一",
    views: 1284000,
    description:
      "少年艾尔在一次意外的星门事故中获得了与古老星图沟通的能力，从此踏上横跨银河的远航。他要面对的是被遗忘的文明、失落的同伴以及宇宙深处正在苏醒的威胁。热血与泪点齐飞的太空史诗，每一集都在刷新你对星海的想象。",
    latestEpisode: "第 24 集",
    updatedAt: "2026-10-12",
  },
  {
    id: "sakura-promise",
    title: "樱花之约",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20two%20high%20school%20students%20standing%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20sakura%20pink%20pastel%20color%20palette%2C%20clean%20minimal%20gradient%20background%2C%20warm%20cinematic%20lighting%2C%20delicate%20digital%20painting%2C%20romantic%20youthful%20atmosphere%2C%20no%20text&width=400&height=560&seq=anime-cover-02&orientation=portrait",
    categories: ["恋爱", "校园", "治愈"],
    region: "日本",
    year: 2023,
    episodes: 12,
    status: "已完结",
    rating: 8.7,
    director: "小林绫",
    views: 962000,
    description:
      "故事围绕转学生咲与青梅竹马两人之间那句未说出口的约定展开。四月的樱花落下时，重逢与告别同时到来。细腻的日常描写与克制的情绪表达，让这部作品成为治愈系恋爱的代表作。",
    latestEpisode: "第 12 集",
    updatedAt: "2026-09-30",
  },
  {
    id: "sword-spirit",
    title: "剑与灵域",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20wandering%20swordsman%20holding%20a%20glowing%20spirit%20blade%2C%20soft%20sakura%20pink%20and%20azure%20highlights%2C%20clean%20minimal%20gradient%20background%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%20digital%20painting%2C%20epic%20atmosphere%2C%20no%20text&width=400&height=560&seq=anime-cover-03&orientation=portrait",
    categories: ["奇幻", "冒险", "热血"],
    region: "中国",
    year: 2024,
    episodes: 36,
    status: "连载中",
    rating: 8.9,
    director: "陆之行",
    views: 1530000,
    description:
      "灵域崩塌之后，剑修的少年背负着整个门派的希望走出深山。他要寻找的不是复仇，而是让灵域重生的那把剑。东方奇幻世界观与凌厉的战斗作画相结合，打斗场面堪称一绝。",
    latestEpisode: "第 36 集",
    updatedAt: "2026-10-10",
  },
  {
    id: "code-09",
    title: "未来代号：09",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20lone%20cyberpunk%20girl%20with%20glowing%20azure%20eyes%20standing%20in%20a%20neon%20rainy%20city%2C%20soft%20pink%20and%20blue%20color%20palette%2C%20clean%20minimal%20gradient%20background%2C%20moody%20cinematic%20lighting%2C%20detailed%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20landscape%20of%20a%20futuristic%20neon%20city%20at%20night%20with%20soft%20pink%20and%20blue%20light%20reflections%20in%20the%20rain%2C%20moody%20atmospheric%20lighting%2C%20detailed%20digital%20painting%2C%20epic%20composition%2C%20no%20text&width=1600&height=700&seq=anime-banner-04&orientation=landscape",
    categories: ["科幻", "悬疑"],
    region: "日本",
    year: 2025,
    episodes: 10,
    status: "连载中",
    rating: 8.4,
    director: "高野澈",
    views: 784000,
    description:
      "代号 09 是实验室里最后一个没有记忆的试验体。当她在雨夜中醒来，整座城市的秘密都开始向她汇聚。冷峻的赛博氛围之下，藏着关于身份与自由的追问。",
    latestEpisode: "第 10 集",
    updatedAt: "2026-10-08",
  },
  {
    id: "love-molecule",
    title: "恋色分子",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20cheerful%20schoolgirl%20holding%20colorful%20balloons%20in%20a%20sunny%20classroom%2C%20soft%20sakura%20pink%20pastel%20palette%2C%20clean%20minimal%20gradient%20background%2C%20bright%20warm%20lighting%2C%20delicate%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-05&orientation=portrait",
    categories: ["恋爱", "日常", "搞笑"],
    region: "日本",
    year: 2022,
    episodes: 13,
    status: "已完结",
    rating: 8.1,
    director: "森野步",
    views: 611000,
    description:
      "理科生视角下的青春恋爱实验：把心动当成一道需要验证的方程式。轻松幽默的日常推进里，藏着最真实的心跳瞬间，适合下饭一口气看完。",
    latestEpisode: "第 13 集",
    updatedAt: "2026-09-18",
  },
  {
    id: "azure-chronicle",
    title: "苍岚纪",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20wind%20mage%20summoning%20a%20spiral%20of%20azure%20air%20currents%2C%20soft%20pink%20and%20blue%20color%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dynamic%20cinematic%20lighting%2C%20high%20detail%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-06&orientation=portrait",
    categories: ["奇幻", "冒险", "热血"],
    region: "中国",
    year: 2024,
    episodes: 28,
    status: "连载中",
    rating: 9.0,
    director: "白鹭工作室",
    views: 1120000,
    description:
      "当天空之城坠落，风之契约者必须重新拾起被封印的力量。以风为主题的东方幻想世界，画面辽阔、配乐大气，是近年国产奇幻动画的亮眼之作。",
    latestEpisode: "第 28 集",
    updatedAt: "2026-10-06",
  },
  {
    id: "mechanical-heart",
    title: "机械之心",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20friendly%20humanoid%20robot%20with%20a%20glowing%20heart%20core%2C%20soft%20pink%20and%20steel%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20warm%20cinematic%20lighting%2C%20detailed%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-07&orientation=portrait",
    categories: ["科幻", "热血", "治愈"],
    region: "日本",
    year: 2023,
    episodes: 24,
    status: "已完结",
    rating: 8.6,
    director: "日向野真",
    views: 833000,
    description:
      "人造人少年想要证明自己拥有的不只是程序，还有一颗真正的心。机械与温情并存的成长故事，看到最后很难忍住眼泪。",
    latestEpisode: "第 24 集",
    updatedAt: "2026-09-25",
  },
  {
    id: "summer-echo",
    title: "夏日回声",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20teenagers%20cycling%20along%20a%20seaside%20road%20at%20golden%20sunset%2C%20soft%20sakura%20pink%20and%20amber%20palette%2C%20clean%20minimal%20gradient%20background%2C%20warm%20nostalgic%20lighting%2C%20delicate%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-08&orientation=portrait",
    categories: ["治愈", "校园", "日常"],
    region: "日本",
    year: 2024,
    episodes: 12,
    status: "连载中",
    rating: 8.8,
    director: "雨宫汐",
    views: 702000,
    description:
      "一个小镇、一群少年、一整个夏天。蝉鸣与海风交织的日子里，他们学着和过去的自己告别。画面美到每一帧都能当壁纸。",
    latestEpisode: "第 12 集",
    updatedAt: "2026-10-04",
  },
  {
    id: "dark-academy",
    title: "暗夜学园",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20mysterious%20student%20standing%20in%20a%20dim%20school%20corridor%20lit%20by%20pink%20moonlight%2C%20muted%20pink%20and%20deep%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20suspenseful%20cinematic%20lighting%2C%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-09&orientation=portrait",
    categories: ["悬疑", "校园", "奇幻"],
    region: "日本",
    year: 2023,
    episodes: 24,
    status: "已完结",
    rating: 8.3,
    director: "雾岛圭",
    views: 655000,
    description:
      "午夜钟声敲响后，学园里会多出一间不存在的教室。为了找回失踪的同伴，少年们必须解开层层谜题。氛围感拉满的校园悬疑佳作。",
    latestEpisode: "第 24 集",
    updatedAt: "2026-09-16",
  },
  {
    id: "dragon-lineage",
    title: "龙裔传说",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20dragon%20rider%20with%20a%20soaring%20pink%20and%20blue%20dragon%2C%20soft%20sakura%20and%20azure%20highlights%2C%20clean%20minimal%20gradient%20background%2C%20epic%20cinematic%20lighting%2C%20high%20detail%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20landscape%20of%20a%20great%20pink%20and%20blue%20dragon%20soaring%20over%20misty%20mountains%20at%20dawn%2C%20dramatic%20glowing%20sky%2C%20atmospheric%20lighting%2C%20detailed%20digital%20painting%2C%20epic%20composition%2C%20no%20text&width=1600&height=700&seq=anime-banner-02&orientation=landscape",
    categories: ["奇幻", "热血", "冒险"],
    region: "中国",
    year: 2025,
    episodes: 40,
    status: "连载中",
    rating: 9.1,
    director: "龙渊社",
    views: 1640000,
    description:
      "最后一个龙裔少年在废墟中孵化出了属于他的龙。从此天涯海角，他与巨龙并肩飞行。宏大的世界观、燃到爆的空战场面，追番党的年度必看。",
    latestEpisode: "第 40 集",
    updatedAt: "2026-10-13",
  },
  {
    id: "cafe-afternoon",
    title: "咖啡馆的午后",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20cozy%20sunlit%20cafe%20with%20a%20barista%20and%20a%20cat%2C%20soft%20sakura%20pink%20and%20cream%20palette%2C%20clean%20minimal%20gradient%20background%2C%20warm%20gentle%20lighting%2C%20delicate%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-11&orientation=portrait",
    categories: ["日常", "治愈"],
    region: "日本",
    year: 2022,
    episodes: 12,
    status: "已完结",
    rating: 7.9,
    director: "小豆沢雫",
    views: 489000,
    description:
      "街角那家咖啡馆里，每个下午都有一位带着故事而来的客人。慢慢煮一杯咖啡，慢慢听完一段人生。治愈系日常的温柔范本。",
    latestEpisode: "第 12 集",
    updatedAt: "2026-09-12",
  },
  {
    id: "time-echo",
    title: "时空回响",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20teen%20standing%20before%20glowing%20time%20rifts%2C%20soft%20pink%20and%20electric%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20sci-fi%20cinematic%20lighting%2C%20detailed%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-12&orientation=portrait",
    categories: ["科幻", "悬疑", "冒险"],
    region: "美国",
    year: 2024,
    episodes: 16,
    status: "连载中",
    rating: 8.5,
    director: "Ava Lindström",
    views: 897000,
    description:
      "每一次时间跳跃都会留下回响，而回响正在吞噬现实。少女必须在下一次崩塌前修正所有错误的时间线。硬核设定与情感张力兼具。",
    latestEpisode: "第 16 集",
    updatedAt: "2026-10-02",
  },
  {
    id: "blaze-fist",
    title: "热血拳道",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20determined%20boxer%20raising%20his%20fist%20in%20a%20ring%20of%20pink%20spotlights%2C%20soft%20sakura%20pink%20and%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dynamic%20dramatic%20lighting%2C%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-13&orientation=portrait",
    categories: ["热血", "运动"],
    region: "日本",
    year: 2021,
    episodes: 25,
    status: "已完结",
    rating: 8.2,
    director: "铁山刚",
    views: 573000,
    description:
      "被打倒一百次，就站起来一百零一次。少年拳手用一整部动画告诉你，天赋从不是唯一的答案。燃向运动番的经典之选，看一集就上头。",
    latestEpisode: "第 25 集",
    updatedAt: "2026-08-30",
  },
  {
    id: "flower-witch",
    title: "花之魔女",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20gentle%20witch%20surrounded%20by%20blooming%20magical%20flowers%2C%20soft%20sakura%20pink%20and%20mint%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dreamy%20cinematic%20lighting%2C%20detailed%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-14&orientation=portrait",
    categories: ["奇幻", "治愈", "冒险"],
    region: "日本",
    year: 2024,
    episodes: 24,
    status: "连载中",
    rating: 8.9,
    director: "花园利绘",
    views: 741000,
    description:
      "能够听见花语的魔女，为每一朵将谢的花寻找归宿。她在旅途中遇见的每个人，都被她悄悄治愈。画面如花园般绚烂，故事却温柔得让人鼻酸。",
    latestEpisode: "第 24 集",
    updatedAt: "2026-10-09",
  },
  {
    id: "azure-reverie",
    title: "蔚蓝残响",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20two%20figures%20under%20a%20vast%20azure%20sky%20with%20floating%20light%20particles%2C%20soft%20pink%20and%20deep%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dreamy%20cinematic%20lighting%2C%20delicate%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-15&orientation=portrait",
    categories: ["科幻", "恋爱", "治愈"],
    region: "日本",
    year: 2025,
    episodes: 12,
    status: "连载中",
    rating: 8.6,
    director: "青木遥",
    views: 668000,
    description:
      "在声音被保存成数据的时代，女主角遇见了能让她听见「残响」的男孩。关于记忆、声音与爱的未来系恋爱物语，音乐性和画面同样出色。",
    latestEpisode: "第 12 集",
    updatedAt: "2026-10-01",
  },
  {
    id: "sky-city-tale",
    title: "天空之城物语",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20floating%20island%20city%20in%20the%20clouds%20with%20a%20small%20adventurer%2C%20soft%20sakura%20pink%20and%20sky%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20epic%20airy%20cinematic%20lighting%2C%20digital%20painting%2C%20no%20text&width=400&height=560&seq=anime-cover-16&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20landscape%20of%20a%20luminous%20floating%20island%20city%20among%20soft%20pink%20clouds%2C%20vast%20open%20sky%2C%20dreamy%20atmospheric%20lighting%2C%20detailed%20digital%20painting%2C%20epic%20composition%2C%20no%20text&width=1600&height=700&seq=anime-banner-03&orientation=landscape",
    categories: ["奇幻", "冒险", "治愈"],
    region: "中国",
    year: 2023,
    episodes: 26,
    status: "已完结",
    rating: 9.3,
    director: "云上工作室",
    views: 1890000,
    description:
      "云海之上漂浮着一座无人知晓的城。少年为了寻找失踪的姐姐，踏上了通往天空之城的旅途。辽阔的想象力与温暖的情感交织，是国产动画的满分答卷。",
    latestEpisode: "第 26 集",
    updatedAt: "2026-09-20",
  },
];

export interface Topic {
  id: string;
  title: string;
  intro: string;
  reason: string;
  cover: string;
  animeIds: string[];
}

export const topics: Topic[] = [
  {
    id: "must-watch-2025",
    title: "2025 必追新番清单",
    intro:
      "本季度最值得投入时间的几部新番，涵盖科幻、奇幻与恋爱多个类型，追番党照着看就对了。",
    reason: "由编辑组结合热度与口碑综合挑选，均为近期更新中的高讨论度作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20collage%20banner%20of%20new%20season%20heroes%20under%20a%20bright%20sky%2C%20soft%20sakura%20pink%20and%20sky%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20vibrant%20cinematic%20lighting%2C%20digital%20painting%2C%20no%20text&width=800&height=500&seq=topic-cover-01&orientation=landscape",
    animeIds: ["dragon-lineage", "code-09", "azure-reverie", "mechanical-heart"],
  },
  {
    id: "healing-collection",
    title: "深夜治愈系精选",
    intro:
      "当你需要一个温柔的夜晚，这几部治愈作品会陪你把情绪慢慢放下来，适合睡前安静地看。",
    reason: "以温暖的日常与细腻的情感为核心，画面柔和、节奏舒缓，是放松身心的首选。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20banner%20of%20a%20cozy%20warm%20town%20at%20dusk%20with%20soft%20pink%20sky%2C%20gentle%20pastel%20palette%2C%20clean%20minimal%20gradient%20background%2C%20warm%20cozy%20lighting%2C%20delicate%20digital%20painting%2C%20no%20text&width=800&height=500&seq=topic-cover-02&orientation=landscape",
    animeIds: ["summer-echo", "cafe-afternoon", "sakura-promise", "flower-witch"],
  },
  {
    id: "epic-world",
    title: "宏世界观冒险专区",
    intro:
      "从星海到天空之城，这里有最辽阔的想象力。喜欢大世界与热血冒险的你，一定不能错过。",
    reason: "以世界观构建和冒险叙事见长，画面恢弘、剧情跌宕，适合喜欢沉浸式追番的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20banner%20of%20floating%20islands%20and%20distant%20galaxies%20combined%2C%20soft%20sakura%20pink%20and%20azure%20palette%2C%20clean%20minimal%20gradient%20background%2C%20epic%20cinematic%20lighting%2C%20digital%20painting%2C%20no%20text&width=800&height=500&seq=topic-cover-03&orientation=landscape",
    animeIds: ["sky-city-tale", "star-voyage", "sword-spirit", "azure-chronicle"],
  },
  {
    id: "guochuang-power",
    title: "国创崛起力量",
    intro:
      "近年来国产动画佳作成批涌现，本期专题带你回顾其中最具代表性的几部作品。",
    reason: "聚焦国创动画的制作水准与原创故事，见证属于我们自己的幻想世界。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20banner%20of%20ancient%20eastern%20mountains%20with%20flying%20dragons%2C%20soft%20pink%20and%20jade%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20cinematic%20lighting%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=topic-cover-04&orientation=landscape",
    animeIds: ["sky-city-tale", "dragon-lineage", "azure-chronicle", "sword-spirit"],
  },
];